const simulatorForm = {
    bindings: {
        trainNumbers: '<',
        simulatorScripts: '<',
        runs: '<',
        loading: '<',
        stations: '<',
        onBeginSimulation: '&'
    },
    templateUrl: '/modules/pis-tool/simulator/simulator-form/simulator-form.html',
    controller: 'SimulatorFormController',
};

angular
    .module('pis-tool.module')
    .component('simulatorForm', simulatorForm)
    .config(function ($stateProvider) {
        $stateProvider.state('pis.workspaces.simulator.form', {
            url: '/setup',
            views: {
                'simulatorView@pis.workspaces.simulator': 'simulatorForm',
            },
        });
    });
